import { CircularProgress, Box } from '@mui/material';
import { Card } from "react-bootstrap";
import LabelReadMoreReadLess from "../LabelReadMoreReadLess/LabelReadMoreReadLess";

export default function DescriptionSociete({ loading, description }) {
  return (
    <Card style={{ padding: 30, width: "100%", maxHeight: "44vh" }}>
      <h5 style={{ color: '#0f172a', fontFamily: "'Fira Sans', sans-serif", fontWeight: 700, fontSize: '1rem' }}>
        Description de la société:
      </h5>
      {loading ? (
        <Box display="flex" height={150} alignItems="center" justifyContent="center">
          <CircularProgress />
        </Box>
      ) : (
        <LabelReadMoreReadLess data={description !== null ? description : "(vide)"} />
      )}
    </Card>
  );
}
